import React from 'react'

const PrivacyPolicy = () => {
    return (
    <div style={{paddingLeft: '5vw', fontFamily: 'tw_cen_mt, serif'}} >
        <h1>Privacy Policy relativa all'API di Google</h1>
        <p>
            Questa privacy policy riguarda l'utilizzo dei dati dell'utente nel caso l'agenda venga collegata ad un account di Google.<br/>
            Per garantire il corretto funzionamento del software di NACplan quando si è connessi ad un account di Google, verranno presi ad ogni accesso i dati riportati di seguito per effettuare una verifica sull'esistenza di un calendario chiamato NACplan, dove poter creare gli eventi.<br/>
            I dati verranno eliminati immediatamente dopo aver fatto la verifica e non verranno comunque mai salvati al di fuori della memoria RAM del server di NACplan.<br />
            I dati a cui avrà accesso il server di NACplan sono i seguenti:
        </p>
        <p>Una lista dei calendari dell'utente di google con questi dati per ogni calendario:</p>
        <ul style={{paddingLeft: '5vw'}} >
            <li><strong>Ruolo di Accesso Utente:</strong>
                <ul>
                    <li><strong>Reader:</strong>
                        <ul>
                            <li>Fornisce accesso in lettura al calendario.</li>
                            <li>Gli eventi privati verranno mostrati agli utenti con accesso in lettura, ma i dettagli degli eventi verranno nascosti.</li>
                        </ul>
                    </li>
                    <li><strong>Writer:</strong>
                        <ul>
                            <li>Fornisce accesso in lettura e scrittura al calendario.</li>
                            <li>Gli eventi privati verranno mostrati agli utenti con accesso in scrittura e i dettagli degli eventi saranno visibili.</li>
                        </ul>
                    </li>
                    <li><strong>Owner:</strong>
                        <ul>
                            <li>Fornisce la proprietà del calendario.</li>
                            <li>Questo ruolo ha tutte le autorizzazioni del ruolo Autore con la possibilità aggiuntiva di visualizzare e manipolare gli ACL.</li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li><strong>BackgroundColor:</strong>
                <ul>
                    <li>Il colore principale del calendario nel formato esadecimale "#0088aa". Questa proprietà sostituisce la proprietà colorId basata su indice.</li>
                    <li>Per impostare o modificare questa proprietà, devi specificare colorRgbFormat=true nei parametri dei metodi insert, update e patch. (Facoltativo) scrivibile</li>
                </ul>
            </li>
            <li><strong>ColorId:</strong>
                <ul>
                    <li>Il colore del calendario. Si tratta di un ID che fa riferimento a una voce nella sezione calendar della definizione dei colori (consulta l'endpoint dei colori). Questa proprietà è sostituita dalle proprietà backgroundColor e foregroundColor e può essere ignorata quando si utilizzano queste proprietà. (Facoltativo) scrivibile</li>
                </ul>
            </li>
            <li><strong>Proprietà delle conferenze per questo calendario, inclusi i tipi di soluzioni di conferenza supportati. Le soluzioni possono essere:</strong>
                <ul>
                    <li>"eventHangout"</li>
                    <li>"eventNamedHangout"</li>
                    <li>"hangoutsMeet" (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>Default Reminders:</strong>
                <ul>
                    <li>Promemoria predefiniti disponibili per l'utente autenticato per questo calendario. È necessario specificare il metodo (email o popup) e il numero di minuti prima dell'inizio dell'evento quando si aggiunge un promemoria. (Obbligatorio)</li>
                </ul>
            </li>
            <li><strong>Deleted:</strong>
                <ul>
                    <li>Indica se la voce dell'elenco dei calendari è stata eliminata dall'elenco. Questo attributo è di sola lettura. (Facoltativo, default: False)</li>
                </ul>
            </li>
            <li><strong>Description:</strong>
                <ul>
                    <li>Descrizione del calendario. Questa proprietà è di sola lettura. (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>Etag:</strong>
                <ul>
                    <li>ETag della risorsa.</li>
                </ul>
            </li>
            <li><strong>ForegroundColor:</strong>
                <ul>
                    <li>Il colore in primo piano del calendario nel formato esadecimale "#ffffff". Questa proprietà sostituisce la proprietà ColorId basata su indice.</li>
                    <li>Per impostare o modificare questa proprietà, è necessario specificare colorRgbFormat=true nei parametri dei metodi insert, update, e patch. (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>Hidden:</strong>
                <ul>
                    <li>Indica se il calendario è stato nascosto dall'elenco. Questo attributo viene restituito solo quando il calendario è nascosto, nel qual caso è true. (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>ID:</strong>
                <ul>
                    <li>Identificatore univoco del calendario.</li>
                </ul>
            </li>
            <li><strong>Kind:</strong>
                <ul>
                    <li>Tipo della risorsa ("calendar#calendarListEntry").</li>
                </ul>
            </li>
            <li><strong>Location:</strong>
                <ul>
                    <li>Posizione geografica del calendario come testo in formato libero. Questa proprietà è di sola lettura. (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>Notification Settings:</strong>
                <ul>
                    <li>Notifiche ricevute dall'utente autenticato per questo calendario. È possibile impostare diverse notifiche, specificando il metodo (email) e il tipo di notifica ("eventCreation", "eventChange", "eventCancellation", "eventResponse", "agenda"). (Obbligatorio per le notifiche)</li>
                </ul>
            </li>
            <li><strong>Primary:</strong>
                <ul>
                    <li>Indica se il calendario è il calendario principale dell'utente autenticato. Questo attributo è di sola lettura. (Facoltativo, default: False)</li>
                </ul>
            </li>
            <li><strong>Selected:</strong>
                <ul>
                    <li>Indica se i contenuti del calendario sono visualizzati nell'interfaccia utente del calendario. Questo attributo è di sola lettura. (Facoltativo, default: False)</li>
                </ul>
            </li>
            <li><strong>Summary:</strong>
                <ul>
                    <li>Titolo del calendario. Questa proprietà è di sola lettura.</li>
                </ul>
            </li>
            <li><strong>Summary Override:</strong>
                <ul>
                    <li>Il riepilogo impostato dall'utente autenticato per questo calendario. (Facoltativo)</li>
                </ul>
            </li>
            <li><strong>TimeZone:</strong>
                <ul>
                    <li>Il fuso orario del calendario. Questa proprietà è di sola lettura. (Facoltativo)</li>
                </ul>
            </li>

        </ul>
    </div>
    )
} 

export default PrivacyPolicy